import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { StationService } from 'src/app/services/station.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReservationService } from 'src/app/services/reservation.service';
import * as moment from 'moment';
@Component({
  selector: 'app-add-contract-service',
  templateUrl: './add-contract-service.component.html',
  styleUrls: ['./add-contract-service.component.scss']
})
export class AddContractServiceComponent implements OnInit {
  minDate = new Date();
  today = moment().format('MM/DD/YYYY');
  // contractTypes = ['AMEX', 'Retail'];
  contractTypes :any;
  statusTypes = [{
    id: false,
    name: "InActive"
  },
  {
    id: true,
    name: "Active"
  }
  ]
  contractForm: FormGroup;
  isEditMode = false;
  formTitle = '';
  submitted = false
  contractServicesData: any;
  selectedStations = [];
  allStations: any;
  selectedContractType: any;
  contractByStationId;
  contractServicesId;
  isAmountChanged = false;
  public constructor(
    private notifier: NotifierService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private authService: AuthenticationService,
    private router: Router,
    private reservationService: ReservationService,
    private stationService: StationService,
    private employeeService: EmployeeService,
    private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.getStations();
    this.getAllContractTypes()
    if (this.route.snapshot.paramMap.get('cid') != null && this.route.snapshot.paramMap.get('sid') != null) {
      this.formTitle = "Update Contract Service";
      this.isEditMode = true;
      this.contractByStationId = this.route.snapshot.paramMap.get('cid');
      this.contractServicesId = this.route.snapshot.paramMap.get('sid');
      this.getContractServiceByIDs(this.route.snapshot.paramMap.get('cid'), this.route.snapshot.paramMap.get('sid'));
    } else {
      this.formTitle = "Add Contract Service"
    }
    this.initAddContractForm();
  }


  getStations() {
    if (this.authenticationService.isStationAdmin()) {
      // get login user stations
      this.employeeService.getEmployeeById(this.authenticationService.getCurrentUserId()).subscribe(res => {
        this.allStations = res['result']['stations']
      })
    } else {
      // get all stations
      this.stationService.getStations().subscribe(stations => {
        this.allStations = stations['result'];
      })
    }
  }
  getAllContractTypes(){
    this.reservationService.getContractTypes().subscribe(res => {
      this.contractTypes = res['result'];
    });
  }
  getContractServiceByIDs(cid, sid) {
    this.selectedStations = [];
    this.spinner.show();
    this.reservationService.getContractServicesByIds(cid, sid).subscribe(employee => {
      this.contractServicesData = employee['result']
      this.selectedStations.push(this.contractServicesData.contract[0].STATIONID);
      this.spinner.hide();
      this.initUpdateContractForm();
    });
  }

  onAddContract(values) {
    this.submitted = true;
    this.validateContract();
    this.contractForm.markAllAsTouched();
    if (this.contractForm.invalid) {
      return;
    }
    if (! (moment(values.effectsDate).isSameOrAfter(moment(this.today)) ) ){
      this.notifier.notify('warning', 'Effective start date should be today or future date!');
      return false;
    }
    var data = {
      contractId: values.contractID,
      stationId: values.stations,
      contractType: values.contractType,
      amount: values.amount,
      shortDesc: values.shortDescription,
      longDesc: values.longDescription,
      lcbId: this.authService.getCurrentUserId(),
      active: true,
      effectiveStartDate: moment(values.effectsDate).format('MM/DD/YYYY'),
    }

    this.spinner.show()
    this.reservationService.insertContractService(data).subscribe(res => {
      if (res['status']) {
        this.spinner.hide()
        this.submitted = false
        this.notifier.notify('success', res['message']);
       // this.initAddContractForm();
        this.router.navigateByUrl("home/contracts");
      } else {
        this.submitted = false
        this.spinner.hide()
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      // console.log(err);
    })
    this.router.navigateByUrl("home/contracts");
  }


  initAddContractForm() {
    let st = moment().format('MM/DD/YYYY');
    this.contractForm = new FormGroup({
      contractID: new FormControl('', Validators.compose([Validators.required])),
      shortDescription: new FormControl('', Validators.compose([Validators.required])),
      longDescription: new FormControl('', Validators.compose([Validators.required])),
      stations: new FormControl('', Validators.compose([Validators.required])),
      amount: new FormControl('', Validators.compose([Validators.required])),
      contractType: new FormControl('', Validators.compose([Validators.required])),
      active: new FormControl(true, Validators.compose([Validators.required])),
      effectsDate: new FormControl(st, Validators.compose([Validators.required])),
    });
  }
  initUpdateContractForm() {

    let st = moment(this.contractServicesData.service[0].EFFECTIVE_START_DATE).format('MM/DD/YYYY');
    // console.log(st);
    // console.log(this.contractServicesData.service[0].EFFECTIVE_START_DATE);
    this.contractForm = this.formBuilder.group({
      contractType: new FormControl(this.contractServicesData.contract[0].CONTRACT_TYPE, Validators.compose([Validators.required])),
      contractID: new FormControl(this.contractServicesData.contract[0].CONTRACTID, Validators.compose([Validators.required])),
      stations: new FormControl(this.selectedStations, Validators.compose([Validators.required])),
      shortDescription: new FormControl(this.contractServicesData.service[0].SHORTDESC, Validators.compose([Validators.required])),
      longDescription: new FormControl(this.contractServicesData.service[0].LONGDESC, Validators.compose([Validators.required])),
      amount: new FormControl(this.contractServicesData.service[0].AMOUNT, Validators.compose([Validators.required])),
      active: new FormControl(this.contractServicesData.service[0].ACTIVE, Validators.compose([Validators.required])),
      effectsDate: new FormControl(st, Validators.compose([Validators.required]))
    });
  }
  get contractFormcontrols() { return this.contractForm.controls; }

  onUpdateContract(values) {
    //console.log(values);
    this.submitted = true
    this.validateContract();
    this.contractForm.markAllAsTouched();
    if (this.contractForm.invalid) {
      return;
    }
    let amountChangeObject;
    //  console.log(this.contractServicesData.service[0].AMOUNT,values.amount);
    if (values.amount !== this.contractServicesData.service[0].AMOUNT) {
      if (moment(values.effectsDate).isBefore(this.minDate)) {
        this.notifier.notify('warning', 'Effective start date should be future date for Changed Amount!');
        return false;
      }

      amountChangeObject = {
        changeAmount: true,
        oldAmount: this.contractServicesData.service[0].AMOUNT,
        effectiveStartDate: moment(this.contractServicesData.service[0].EFFECTIVE_START_DATE).format('MM/DD/YYYY'),
        effectiveEndDate: moment(values.effectsDate).subtract(1, 'days').startOf('day').format('MM/DD/YYYY'),
        contractServicesId: parseInt(this.contractServicesId)
      }
    } else {
      amountChangeObject = {
        changeAmount: false
      }
    }
    var data = {
      contractId: values.contractID,
      stationId: values.stations,
      contractType: values.contractType,
      amount: values.amount,
      shortDesc: values.shortDescription,
      longDesc: values.longDescription,
      contractByStationId: parseInt(this.contractByStationId),
      contractServicesId: parseInt(this.contractServicesId),
      lcbId: this.authService.getCurrentUserId(),
      active: values.active,
      effectiveStartDate: moment(values.effectsDate).format('MM/DD/YYYY'),
      amountChange: amountChangeObject
    }
    this.spinner.show();
    this.reservationService.updateContractService(data).subscribe(res => {
      this.spinner.hide();
      if (res['status']) {
        this.notifier.notify('success', res['message']);
        setTimeout(() => {
          // this.location.back();
         // this.ngOnInit();
          this.router.navigateByUrl("home/contracts");
        }, 1000);
      } else {
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }

  onStationChange(event) {
    this.selectedStations = (event)
  }
  validation_messages = {
    'contractID': [
      { type: 'required', message: 'Contract ID is required.' }
    ],
    'contractType': [
      { type: 'required', message: 'Contract Type is required.' }
    ],
    'longDescription': [
      { type: 'required', message: 'Long Description is required.' }
    ],
    'shortDescription': [
      { type: 'required', message: 'Short Description is required.' }
    ],
    'amount': [
      { type: 'required', message: 'Amount is required.' }
    ],
    'stations': [
      { type: 'required', message: 'Station is required.' }
    ],
    'active': [
      { type: 'required', message: 'Status is required.' }
    ],
    'effectsDate': [
      { type: 'required', message: 'Effective Date is required.' }
    ]

  }

  get f(): any {
    return this.contractForm.controls;
  }

  onBack() {
    // this.location.back();
    this.router.navigateByUrl("home/contracts");
  }

  validateContract() {
    //console.log("callingg...");
    if (this.contractFormcontrols.contractID.errors) {
      this.notifier.notify('warning', 'Please enter Contract ID');
      return false;
    }
    if (this.contractFormcontrols.contractType.errors) {
      this.notifier.notify('warning', 'Please select Contract Type ');
      return false;
    }
    if (this.contractFormcontrols.stations.errors) {
      this.notifier.notify('warning', 'Please select Station');
      return false;
    }
    if (this.contractFormcontrols.amount.errors) {
      this.notifier.notify('warning', 'Please enter Amount');
      return false;
    }
    if (this.contractFormcontrols.shortDescription.errors) {
      this.notifier.notify('warning', 'Please enter short Description');
      return false;
    }
    if (this.contractFormcontrols.longDescription.errors) {
      this.notifier.notify('warning', 'Please enter Long Description ');
      return false;
    }
  }


  formatDateTime(effectDate) {
    let date = moment(effectDate).format('YYYY-MM-DD');
    return moment(date);
  }


  amountChangeCheckingFn(event) {
   // console.log(event.value)
    if (event.value !== this.contractServicesData.service[0].AMOUNT) {
     // console.log("Amount Changed.........");
     // console.log('log');
      this.isAmountChanged = true;
    } else {
      this.isAmountChanged = false;
    }
  }

}
